export enum GspServiceKey {
  Intranet = 'intranet',
  ZrStat = 'zr_stat', // former `ZRBI` (until 2026-04)
  ZrStatNew = 'zr_stat_new', // new `ZR-Statistik`(former ZRBI) service (from 2026-09)
  Katalog = 'katalog',
  ZrPortal = 'zr_portal',
  ManageMax = 'managemax',
  VmeAkad = 'vme_akad',
  VmeComm = 'vme_comm',
  LieferantenDaten = 'lief_dat',
  LieferantenPortal = 'lief_portal',
  BlockSpot = 'block_spot',

  // staging only currently
  Piex = 'piex',
}

export const GspServiceLabels: Record<GspServiceKey, string> = {
  [GspServiceKey.Intranet]: 'Intranet & Konditionsverwaltung',
  [GspServiceKey.ZrStat]: 'ZR-Statistik',
  [GspServiceKey.ZrStatNew]: 'ZR-Statistik (Neu)',
  [GspServiceKey.Katalog]: 'Katalogwand',
  [GspServiceKey.ZrPortal]: 'ZR-Portal',
  [GspServiceKey.ManageMax]: 'ManageMax VME Händlerportal',
  [GspServiceKey.VmeAkad]: 'VME-Akademie',
  [GspServiceKey.VmeComm]: 'VME-Community',
  [GspServiceKey.LieferantenDaten]: 'Lieferantendatenportal',
  [GspServiceKey.LieferantenPortal]: 'Lieferantenportal',
  [GspServiceKey.BlockSpot]: 'Blockverrechnung & Spotmarkt',
  [GspServiceKey.Piex]: 'PIEX',
}

export class GspServicesHelper {
  static getLabel(key: string): string {
    return GspServiceLabels[key as GspServiceKey] || key
  }

  static isValid(key: string): boolean {
    return Object.values(GspServiceKey).includes(key as GspServiceKey)
  }

  static getAll(): Array<{ key: GspServiceKey; label: string }> {
    return Object.values(GspServiceKey).map((key) => ({
      key,
      label: GspServiceLabels[key],
    }))
  }
}